import { render, staticRenderFns } from "./ProductExtra.vue?vue&type=template&id=fbea491a&"
import script from "./ProductExtra.vue?vue&type=script&lang=js&"
export * from "./ProductExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports